import * as moment from 'moment';
import { ReportType } from '@app/domain/model/report-type';
import { Moment } from 'moment';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class StatusCheckParams {

  readonly reportDate: string;

  readonly sellerId: number;

  constructor(){
  }

  static fromFormObject(formObject: any): StatusCheckParams {
    const result = Object.create(StatusCheckParams.prototype);
    let date: Moment = null;
    if( typeof formObject[0] === 'string' && formObject[0] ) {
      date = moment(formObject[0] );
    } else if( typeof formObject[0] === 'object' && formObject[0] !== null && !formObject[0]._isAMomentObject) {
      date = moment(formObject[0].year + '-' + ( formObject[0].month <= 9 ? '0' + formObject[0].month : formObject[0].month ) + '-' + ( formObject[0].day <= 9 ? '0' + formObject[0].day : formObject[0].day ) );
    }

    return Object.assign(result, {
      reportDate: date ? date.format('YYYY-MM-DD') : null,
      sellerId: formObject[1] ? formObject[1].licenseNumber : null
    });
  }

  equals( params: StatusCheckParams ): boolean {
    return params && typeof this.reportDate !== 'undefined' && typeof params.reportDate !== 'undefined' &&  this.reportDate === params.reportDate &&
      typeof this.sellerId !== 'undefined' && typeof params.sellerId !== 'undefined' &&  this.sellerId === params.sellerId;
  }

  complete(): boolean {
    return typeof this.reportDate !== 'undefined' && this.reportDate !== null && this.reportDate !== '' &&
      typeof this.sellerId !== 'undefined' && this.sellerId !== null;
  }
}
